import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const SleazyNetKnitBlack = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.tops.SleazyNetKnitBlack.itemName}
      name={SS23.tops.SleazyNetKnitBlack.itemName}
      price={SS23.tops.SleazyNetKnitBlack.itemPrice}
      fabric={SS23.tops.SleazyNetKnitBlack.itemFabric}
      src={SS23.tops.SleazyNetKnitBlack.sizeChart}
      divId={SS23.tops.SleazyNetKnitBlack.shopifyDivId}
      mainId={SS23.tops.SleazyNetKnitBlack.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.tops.SleazyNetKnitBlack.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.tops.SleazyNetKnitBlack.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default SleazyNetKnitBlack;
